export const GETTERS_LEVEL_PATHS = "GETTERS_LEVEL_PATHS";
export const GETTERS_LIST_PATH_TEMPLATES = "GETTERS_LIST_PATH_TEMPLATES";

export const ACTIONS_GET_LIST_PATHS = "ACTIONS_GET_LIST_PATHS";
export const ACTIONS_GET_LIST_PATH_TEMPLATES =
  "ACTIONS_GET_LIST_PATH_TEMPLATES";
export const ACTIONS_GET_LIST_RAS_PATH_TEMPLATES =
  "ACTIONS_GET_LIST_RAS_PATH_TEMPLATES";
export const ACTIONS_SET_LEVEL_PATHS = "ACTIONS_SET_LEVEL_PATHS";
export const ACTIONS_ADD_PATH_TO_LEVEL = "ACTIONS_ADD_PATH_TO_LEVEL";
export const ACTIONS_DELETE_LEVEL_PATH = "ACTIONS_DELETE_LEVEL_PATH";

export const MUTATIONS_SET_LEVEL_PATHS = "MUTATIONS_SET_LEVEL_PATHS";
export const MUTATIONS_SET_LIST_PATH_TEMPLATES =
  "MUTATIONS_SET_LIST_PATH_TEMPLATES";



// WEBPACK FOOTER //
// ./src/store/modules/basic_paths/constants.js